module.exports = __webpack_public_path__ + "static/media/decada_menemista_y_el_neoliberalismo.97678bcc.md";